import { z } from "zod";

import { PaymentType, ReviewStatus } from "../../status";

export const editablePaymentFields = [
  { name: "fileId", type: "radio", required: false },
  { name: "wieldyId", type: "text", required: false },
  { name: "reviewStatus", type: "dropdown", required: true },
  { name: "practiceId", type: "dropdown", required: true },
  { name: "source", type: "dropdown", required: true },
  { name: "payer", type: "dropdown", required: true },
  { name: "payerPaymentId", type: "text", required: true },
  { name: "paymentDate", type: "date", required: true },
  { name: "eopPaymentAmount", type: "number", required: true },
  { name: "paymentType", type: "dropdown", required: true },
  { name: "paymentStatus", type: "text", required: false },
  { name: "payee", type: "text", required: false },
  { name: "adjustmentAmount", type: "number", required: false },
  { name: "adjustmentType", type: "dropdown", required: false },
] as const;

export const defaultPaymentFields = {
  reviewStatus: ReviewStatus.MODIFIED,
  paymentType: PaymentType.EFT,
};

export const paymentFormSchemaBase = z.object(
  editablePaymentFields.reduce((acc: Record<string, z.ZodType>, field) => {
    if (field.type === "text") {
      acc[field.name] = field.required
        ? z.string().min(3, `${field.name} must be at least 3 characters long`)
        : z.string().optional();
    } else if (field.type === "number") {
      acc[field.name] = field.required ? z.number() : z.number().optional();
    } else if (field.type === "date") {
      acc[field.name] = field.required
        ? z.coerce.date().transform((date) => date.toISOString().split("T")[0])
        : z.coerce
            .date()
            .transform((date) => date.toISOString().split("T")[0])
            .optional();
    } else if (["dropdown", "radio"].includes(field.type)) {
      acc[field.name] = field.required
        ? z.string().min(1, `${field.name} is required`)
        : z.string().optional();
    }
    return acc;
  }, {}),
);

export type AddPaymentFormFields = z.infer<typeof paymentFormSchemaBase>;

export const aiFields = [
  { name: "practiceId", type: "dropdown", required: true },
  { name: "source", type: "dropdown", required: true },
  { name: "payer", type: "dropdown", required: true },
  { name: "documentLevelType", type: "dropdown", required: true },
] as const;

export const AIFormSchemaBase = z.object(
  aiFields.reduce((acc: Record<string, z.ZodType>, field) => {
    if (["dropdown", "radio"].includes(field.type)) {
      acc[field.name] = field.required
        ? z.string().min(1, `${field.name} is required`)
        : z.string().optional();
    }
    return acc;
  }, {}),
);

export type AIPaymentFormFields = z.infer<typeof AIFormSchemaBase>;
